/**
 * Shared DOM id for the profile avatar. Desktop and mobile both render an
 * avatar and both carry this id: the anchored-panel lookup picks whichever one
 * is laid out, the same way the favorite-team target works.
 */
export const PROFILE_AVATAR_TARGET_ID = 'profile-avatar'

/** Which surface asked for the number — the `type` variable on the USER_PHONE_* events. */
export const PHONE_CAPTURE_SURFACES = {
  spotlight: 'spotlight',
  profile: 'profile',
} as const

export type PhoneCaptureSurface = (typeof PHONE_CAPTURE_SURFACES)[keyof typeof PHONE_CAPTURE_SURFACES]

/** Opens that section of the profile. */
export const PROFILE_SECTION_PARAM = 'section'

/**
 * Section keys of the profile screen. They are the contract between a link and
 * the router that reads it, so they live here rather than inside the actor.
 */
export const PROFILE_SECTIONS = {
  PLANS: 'plans',
  PAYMENT_METHOD: 'paymentMethod',
  SITE_LANGUAGE: 'language',
  PERSONAL_INFO: 'personalInfo',
  CHANGE_PASSWORD: 'changePassword',
  DELETE_ACCOUNT: 'deleteAccount',
  HIDE_SCORES: 'hideScores',
  HELP_CENTER: 'support',
  RATE_US: 'rateUs',
  DEFAULT: 'plans'
} as const

/** Names the field to scroll to, focus and mark — see `useHighlightedField`. */
export const FIELD_HIGHLIGHT_PARAM = 'highlight'

const PHONE_FIELD = 'phone'

/** Where every phone-capture surface sends the user to type the number. */
export const PROFILE_PERSONAL_INFO_PATH =
  `/profile?${PROFILE_SECTION_PARAM}=${PROFILE_SECTIONS.PERSONAL_INFO}&${FIELD_HIGHLIGHT_PARAM}=${PHONE_FIELD}`
